import { useContext } from 'react';

import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';

const RedesignedThankYouGreeting = ({ firstName = '' }) => {
  const { user } = useContext(UserContext);
  const { weeklyMeals } = user;

  return (
    <div
      className="mx-auto flex w-full max-w-5xl flex-col items-center justify-center gap-4 self-stretch px-6 py-8 text-center bp1:py-10"
      data-testid="redesigned-thank-you-greeting"
    >
      <Text brandStylesOverrides="h1 text-secondary">{`Welcome, ${firstName}!`}</Text>
      <Text className="self-stretch" brandStylesOverrides="h5 text-charcoal-100">
        {`We picked out ${weeklyMeals} meals for your first box. Take a look and make it yours.`}
      </Text>
    </div>
  );
};

RedesignedThankYouGreeting.propTypes = {
  firstName: PropTypes.string,
};

export default RedesignedThankYouGreeting;
